import { PartnerAccount } from '@tmx/data-access';
import { map, pipe } from 'rxjs';

export function sortAccounts() {
  return pipe(
    map<PartnerAccount[], PartnerAccount[]>((accounts) => {
      return accounts.sort((a, b) => {
        const nameA = a.name.toLowerCase();
        const nameB = b.name.toLowerCase();
        return nameA > nameB ? 1 : nameA < nameB ? -1 : 0;
      });
    })
  );
}
